import { useEffect } from "react";

import useIdle from "react-use/lib/useIdle";
import usePreviousDistinct from "react-use/lib/usePreviousDistinct";

const useIdleEffect = (onIdle: () => void, timeout = 180000, active = true) => {
  const idle = useIdle(timeout, false);
  const prevIdle = usePreviousDistinct(idle);

  useEffect(() => {
    if (!active) {
      return;
    }

    if (!prevIdle && idle) {
      onIdle();
    }
  }, [idle, prevIdle, active]);
};

export default useIdleEffect;
